<template>
  <BaseView
    button-text="Create Voyage"
    :on-main-button-pressed="() => {}"
  >
    <template #content>
      <v-form
        ref="form"
        v-model="valid"
      >
        <div class="main-form-container">
          <VoyageDescriptionComponent />
          <CreateRouteComponent />
          <div class="basic-parameters-container">
            <div class="title-container">
              <span class="basic-parameters-title">Basic parameters</span>
              <InfoIcon :info-data="infoDetails['wr_basic_parameters']" />
            </div>
            <SetFoulingComponent />
            <SetFloatingDataComponent />
            <SetServiceSpeedComponent />
            <PickDateTimeComponent />
            <SetArrivalOptionsComponent />
          </div>
          <ExtraVoyageSettings />
        </div>
      </v-form>
    </template>
    <template #snackbar>
      <RequestResponseSnackBar
        v-model="showErrorSnackBar"
        :value="showErrorSnackBar"
        :text="calculationFailedErrorMessage"
        color="red"
        :timeout="3000"
      />
    </template>
    <template #action>
      <CreateVoyageButton :valid-form="valid" />
      <!-- :validateForm="validateForm" /> -->
    </template>
  </BaseView>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CreateRouteComponent from "./components/create_route_component/CreateRoute.vue";
import PickDateTimeComponent from "./components/voyage_options/PickDateTime.vue";
import SetFoulingComponent from "./components/voyage_options/SetFouling.vue";
import SetServiceSpeedComponent from "./components/voyage_options/SetServiceSpeed.vue";
import SetFloatingDataComponent from "./components/voyage_options/SetFloatingData.vue";
import SetArrivalOptionsComponent from "./components/voyage_options/SetArrivalOptions.vue";
import VoyageDescriptionComponent from "./components/voyage_options/VoyageDescription.vue";
import ExtraVoyageSettings from "./extra_settings/ExtraVoyageSettings.vue";
import CreateVoyageButton from "./components/CreateVoyageButton.vue";
import RequestResponseSnackBar from "../../components/RequestResponseSnackBar.vue";
import BaseView from "../../components/BaseView.vue";
import InfoIcon from "@/core/InfoIcon.vue";

export default {
  name: "WeatherRoutingDrawer",
  components: {
    CreateRouteComponent,
    PickDateTimeComponent,
    SetFoulingComponent,
    SetServiceSpeedComponent,
    SetFloatingDataComponent,
    SetArrivalOptionsComponent,
    VoyageDescriptionComponent,
    ExtraVoyageSettings,
    BaseView,
    CreateVoyageButton,
    RequestResponseSnackBar,
    InfoIcon
  },
  data: function () {
    return {
      valid: true,
      showErrorSnackBar: false,
    };
  },
  computed: {
    ...mapState("main", ["infoDetails"]),
    ...mapState("weatherRouting/formModule", [
      "currentTab",
      "calculationError",
    ]),
    ...mapGetters("weatherRouting/formModule", ["calculationFailed"]),
    currentTabModel: {
      get() {
        return this.currentTab;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_CURRENT_TAB", value, {
          root: true,
        });
      },
    },
    calculationFailedErrorMessage() {
      return `Calculation failed : ${this.calculationError}`;
    },
  },
  watch: {
    calculationFailed: {
      handler(value) {
        this.showErrorSnackBar = value;
      },
      deep: true,
    },
    currentTab: {
      handler() {
        this.removeSelectedRoute();
      },
      deep: true,
    },
  },
  methods: {
    validateForm() {
      return this.$refs.form.validate();
    },
    removeSelectedRoute() {
      this.$store.commit(
        "weatherRouting/routesModule/SET_SELECTED_ROUTE",
        null
      );
    },
  },
};
</script>

<style scoped>
.main-form-container {
  padding: 0px 10px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 10px;
  width: 100%;
  background-color: var(--color-bg);
}

.title-container {
  display: flex;
  align-items: center;
}

.basic-parameters-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-text);
}
.basic-parameters-container {
  background-color: var(--color-bg);
  padding: 10px;
  border-radius: 10px;
  border: 1px solid var(--color-secondary);
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 20px;
  width: 100%;
}
</style>
